// Copy of the website's built-in footer social links (aavryaa_frontend
// Constants/socialLinks.js). The Social Links editor starts from these.
export const SOCIAL_LINKS_DEFAULTS = {
  twitter: "https://twitter.com",
  facebook: "https://facebook.com",
  instagram: "https://www.instagram.com/acchoosclothing?igsh=dHd2NWluOHpzaWM4",
  youtube: "https://youtube.com",
  linkedin: "",
  pinterest: "",
  show: ["twitter", "facebook", "instagram", "youtube"], // visible networks, in order
};

// Networks the footer can show; `domains` is used to warn about a wrong site
export const SOCIAL_NETWORKS = [
  { id: "twitter",   name: "Twitter / X", domains: ["twitter.com", "x.com"], example: "https://x.com/yourpage" },
  { id: "facebook",  name: "Facebook",    domains: ["facebook.com", "fb.com", "fb.me"], example: "https://facebook.com/yourpage" },
  { id: "instagram", name: "Instagram",   domains: ["instagram.com", "instagr.am"], example: "https://instagram.com/yourpage" },
  { id: "youtube",   name: "YouTube",     domains: ["youtube.com", "youtu.be"], example: "https://youtube.com/@yourchannel" },
  { id: "linkedin",  name: "LinkedIn",    domains: ["linkedin.com"], example: "https://linkedin.com/company/yourpage" },
  { id: "pinterest", name: "Pinterest",   domains: ["pinterest.com", "pin.it"], example: "https://pinterest.com/yourpage" },
];

export const SOCIAL_URL_MAX = 300;
